import { Plus, Tag as TagIcon } from "lucide-react";

interface TodoTag {
  id: string;
  name: string;
  color: string;
}

interface TodoTagFormProps {
  tags: TodoTag[];
  newTagName: string;
  setNewTagName: (name: string) => void;
  newTagColor: string;
  setNewTagColor: (color: string) => void;
  onAddTag: () => void;
  canAdd?: boolean;
}

export default function TodoTagForm({
  tags,
  newTagName,
  setNewTagName,
  newTagColor,
  setNewTagColor,
  onAddTag,
  canAdd = true,
}: TodoTagFormProps) {
  if (!canAdd) {
    return null;
  }

  return (
    <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-lg p-6 mb-6 border border-purple-200">
      <div className="flex items-start justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
          <TagIcon className="w-5 h-5 text-purple-600" />
          Yeni Etiket Ekle
        </h3>
        <span className="text-xs text-purple-700 bg-purple-100 px-2 py-1 rounded-full">Maks. 100 etiket</span>
      </div>
      <div className="space-y-3">
        <input
          type="text"
          value={newTagName}
          onChange={(e) => setNewTagName(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-purple-500 focus:border-transparent"
          placeholder="Etiket adı (örn: Önemli, Toplantı, Takip...)"
          onKeyPress={(e) => {
            if (e.key === "Enter" && newTagName.trim()) {
              onAddTag();
            }
          }}
        />
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <div className="flex gap-1.5 sm:gap-2">
            {["#ef4444", "#f59e0b", "#10b981", "#3b82f6", "#8b5cf6", "#ec4899", "#06b6d4", "#f97316"].map((color) => (
              <button
                key={color}
                onClick={() => setNewTagColor(color)}
                className={`w-6 h-6 sm:w-8 sm:h-8 rounded-md transition-all flex-shrink-0 ${
                  newTagColor === color ? "ring-2 ring-offset-1 sm:ring-offset-2 ring-gray-600 scale-110" : "hover:scale-105"
                }`}
                style={{ backgroundColor: color }}
              />
            ))}
          </div>
          <button
            onClick={onAddTag}
            disabled={!newTagName.trim()}
            className="w-full sm:w-auto px-5 py-2 bg-purple-600 text-white rounded-md text-sm font-medium hover:bg-purple-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors inline-flex items-center justify-center gap-2">
            <Plus className="w-4 h-4" />
            Ekle
          </button>
        </div>
      </div>
    </div>
  );
}
